const TICKET_META_SEPARATOR = ' · ';

function isUsableMetaPart(part) {
    if (typeof part === 'number') {
        return Number.isFinite(part);
    }
    return typeof part === 'string' && part.trim() !== '';
}

function joinTicketMeta(parts) {
    const usableParts = parts.filter(isUsableMetaPart).map(part => String(part).trim());
    return usableParts.length > 0 ? usableParts.join(TICKET_META_SEPARATOR) : null;
}

export { TICKET_META_SEPARATOR, joinTicketMeta };
